import {FETCH_ONE_TO_MANY} from "../../actions";

export default (state = [], action) => {
    switch (action.type) {
        case FETCH_ONE_TO_MANY:
            return action.payload;
        default:
            return state;
    }
};